import ArtworkLabel from '../ArtworkLabel';
import { useState } from 'react'
import Canvas from './Canvas';

const RevealCanvas = props => {

    const frameWidth = 0.11
    const canvasSize = props.width * (1 - frameWidth * 2)

    var [hover, setHover] = useState(false)

    return <div style={{
        position: 'relative',
        width: props.width,
        height: props.width,
    }} onClick={() => setHover(!hover)}>
        <div style={{
            position: 'absolute',
            transform: `translate(${frameWidth * 100 * props.width / canvasSize}%, ${frameWidth * 100 * props.width / canvasSize}%)`,
            margin: '0px',
            padding: '0px',
            width: `${canvasSize}px`,
            height: `${canvasSize}px`,
        }}>
            {props.children ? props.children : <Canvas width={canvasSize} data={props.data} hideCursor={false} />}
        </div>
        <div style={{
            position: 'absolute',
            margin: '0px',
            padding: '0px',
            width: `${props.width}px`,
            height: `${props.width}px`,
        }}>
            <img src={process.env.PUBLIC_URL + `/assets/frame4.png`} width={props.width} height={props.width} className="icon" />
        </div>
        {props.label &&
            <div style={{
                position: 'absolute',
                margin: '0px',
                padding: '0px',
                bottom: '-5%',
                right: '-8%',
                left: '20%',
                opacity: hover ? 1 : 0,
                transition: 'opacity 0.5s',
                zIndex: hover ? 100 : -100,
            }}>
                <ArtworkLabel label={props.label} />
            </div>}
    </div>
}

export default RevealCanvas